import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import AppRoutes from './components/AppRoutes';
import Layout from './components/common/Layout';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <Layout>
            <AppRoutes />
          </Layout>
        </AuthProvider>
      </Router>
    </div>
  );
};

export default App;